// @core/api/endpoints/project/clone_project.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CloneProjectRequest,
  ProjectResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Clone project
 * Creates a copy of the project including selected content: boards, epics, labels, and optionally member assignments. Items and sprints are not cloned by default.
 */
export async function CloneProject(
  project_id: string,
  data: CloneProjectRequest,
  options?: RequestOptions
): Promise<ProjectResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/clone`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<ProjectResponse>(requestPath, data, requestOptions);
}
